import ReportRow from './ReportRow'
import ReportField from './ReportField'
import ReportPart from './ReportPart'
import ReportProcess from './ReportProcess'

export default class Report extends ReportRow {
  parts = []
  process = []
  // TODO : translate Header
  header = new ReportPart({ id: 'header' }, 'fr')
  new = false


  parseParts(report, locale) {
    this.parts = report.parts ? report.parts.map((part) => new ReportPart(part, locale)) : []
  }

  parseProcess(report, locale) {
    this.process = report.process ? report.process.map((process) => new ReportProcess(process, locale)) : []
  }

  buildHeader(report, locale) {
    this.header.infos.push(
      new ReportField({
        titleKey: 'report.edit.geoloc.datetime',
        type: 'datetime',
        value: this.finishedAt,
        dropoff_value: this.dropoffFinishedAt,
        dropoff: true,
        required: false,
        readonly: true
      }, locale)
    )

    this.header.infos.push(
      new ReportField({
        titleKey: 'report.edit.geoloc.timestamp',
        type: 'text',
        value: this.finishedAt,
        dropoff_value: this.dropoffFinishedAt,
        dropoff: true,
        required: false,
        readonly: true
      }, locale)
    )

    this.header.infos.push(
      new ReportField({
        titleKey: 'report.edit.geoloc.gps',
        type: 'map',
        value: report.geoloc ? [report.geoloc.latitude, report.geoloc.longitude] : null,
        dropoff_value: report.geoloc_dropoff,
        dropoff: true,
        required: false,
        readonly: true
      }, locale)
    )
  }

  findIdentifier(report, locale) {
    const field = this.parts
      .filter((part) => part.isItemPart)
      .map((part) => part.infos)
      .reduce((acc, val) => acc.concat(val), [])
      .find((item) => item.isIdentifier)

    this.identifier = field ? field.value : null
  }

  parseReport(report, locale) {
    this.parseRow(report, locale)
    this.parseProcess(report, locale)
    this.parseParts(report, locale)
    this.buildHeader(report, locale)
    this.findIdentifier(report, locale)
  }
}
